<template>
  <div class="stationeryRecord-list">
    <el-table :data="currentLabel == '申请统计'
      ? stationeryDetailsList
      : stationeryRecordList
      " border style="width: 100%" tooltip-effect="dark" class="common-edit-button"
      :show-summary="currentLabel == '申请统计' ? true : false">
      <el-table-column prop="teacherName" width="200px" :show-overflow-tooltip="true" label="申请人">
      </el-table-column>
      <el-table-column prop="itemName" width="200px" :show-overflow-tooltip="true" label="申请物品"
        v-if="currentLabel == '申请统计'">
      </el-table-column>
      <el-table-column prop="statusText" width="200px" :show-overflow-tooltip="true" label="状态"
        v-if="currentLabel == '申请统计'">
      </el-table-column>
      <el-table-column prop="quantity" width="200px" :show-overflow-tooltip="true" label="数量" sortable
        v-if="currentLabel == '申请统计'">
      </el-table-column>
      <el-table-column prop="createTime" :show-overflow-tooltip="true" label="申请时间">
      </el-table-column>
      <el-table-column prop="statusText" width="200px" :show-overflow-tooltip="true" label="状态"
        v-if="currentLabel != '申请统计'">
        <template slot-scope="scope" v-if="currentLabel != '申请统计'">
          {{ scope.row.status == '0' ? '待审批' : scope.row.status == '1' ? '已通过' : scope.row.status == '2' ? '已拒绝' : '已撤回' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300px" fixed="right"
        v-if="currentLabel != '申请统计'">
        <template slot-scope="scope" v-if="currentLabel != '申请统计'">
          <div class="operate">
            <!-- 修改 -->
            <el-button type="warning" size="small" @click="editClick(scope.row)"
              v-show="scope.row.status == 0 && currentLabel == '我的申请'" icon="el-icon-edit"
              v-hasPermi="'sc:stationeryrecord:edit'">修改
            </el-button>
            <!-- 审核 -->
            <el-button type="primary" size="small" v-show="scope.row.status == 0 && currentLabel != '我的申请'"
              @click="showDialog(scope.row.id)" icon="el-icon-s-check" v-hasPermi="'sc:stationeryrecord:audit'">审核
            </el-button>
            <!-- 详情 -->
            <el-button type="success" size="small" @click="detailClick(scope.row.id)" v-show="scope.row.status !== 0"
              icon="el-icon-info">详情
            </el-button>
            <el-button type="info" size="small" v-hasPermi="'sc:stationeryrecord:edit'"
              @click="revocationClick(scope.row)" v-show="scope.row.status == 0 && currentLabel == '我的申请'"
              icon="el-icon-delete">撤回
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <stationeryRecordEdit :dialogFormVisible.sync="editShow" :stationeryRecordData="stationeryRecordData"
      :stationeryList="stationeryList" @edit="edit" v-show="editShow" />
    <stationeryRecordDetail :detailShow.sync="detailShow" :stationeryRecordDetail="stationeryRecordDetail"
      v-if="detailShow" />
    <!-- 审核 -->
    <el-dialog title="审核操作" :visible.sync="dialogFormVisible" v-if="dialogFormVisible" center width="30%">
      <el-form :model="form">
        <el-form-item label="审核操作">
          <el-radio v-model="form.status" label="1">同意</el-radio>
          <el-radio v-model="form.status" label="2">拒绝</el-radio>
        </el-form-item>
        <el-form-item label="审核意见">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.feedback">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateStatus">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import stationeryRecordEdit from "../../components/stationeryRecord-edit/stationeryRecordEdit.vue";
import stationeryRecordDetail from "../stationeryRecord-detail/stationeryRecordDetail.vue";
export default {
  name: "",
  components: {
    stationeryRecordEdit,
    stationeryRecordDetail,
  },
  props: {
    stationeryDetailsList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    stationeryRecordList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    stationeryList: {
      type: Array,
    },
    currentLabel: {
      type: String,
    }
  },
  data() {
    return {
      editShow: false,
      detailShow: false,
      stationeryRecordData: null,
      stationeryRecordDetail: null,
      dialogFormVisible: false,
      form: {
        status: "1",
        feedback: "",
      },
    };
  },
  created() { },
  methods: {
    // 撤回点击
    revocationClick(row) {
      this.$confirm("是否撤回该申请?", "撤回", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          let data = {
            "id": row.id,
            "status": '3',
          };
          this.put(this.$url.withdrawStationeryRecord, data)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("撤回成功");
                this.$emit("revocationRefresh", data.id);
              }
            })
            .catch((err) => {
              // console.log(err);
              this.$message.error("撤回失败，请稍后重试");
            });
        })
        .catch(() => { });
    },
    // 审核
    updateStatus() {
      let { status, feedback } = this.form;
      let { id } = this.stationeryRecordDetail;
      // console.log(id,status);
      this.put(this.$url.auditStationeryRecord, {
        status,
        id,
        remark: feedback,
      })
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.$emit("updateStatus", id);
            this.$message.success("操作成功");
            this.dialogFormVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          this.$message.error("操作失败，请稍后重试");
        });
    },
    showDialog(id) {
      this.form = {
        status: "1",
        feedback: "",
      };
      this.get(this.$url.selectStationeryRecordDetailsById + "?id=" + id).then(
        (res) => {
          // console.log("详细信息==>", res);
          if (res.code !== 200) return this.$message.error(res.msg);
          this.stationeryRecordDetail = res.data;
          this.dialogFormVisible = true;
        }
      );
    },
    editClick(item) {
      // console.log(item);
      this.get(
        this.$url.selectStationeryRecordDetailsById + "?id=" + item.id
      ).then((res) => {
        // console.log(res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.stationeryRecordData = res.data;
        this.editShow = true;
      });
    },
    detailClick(id) {
      this.get(this.$url.selectStationeryRecordDetailsById + "?id=" + id).then(
        (res) => {
          // console.log(res);
          if (res.code !== 200) return this.$message.error(res.msg);
          this.detailShow = true;
          this.stationeryRecordDetail = res.data;
        }
      );
      // console.log(this.detailShow);
    },
    edit(e) {
      this.$emit("edit", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./stationeryRecord-list.scss";
</style>
